/**
 * Tracks whether the user has started an on-demand support recording
 * (Session Replay + UI profiling) from the navigation menu.
 *
 * Sentry tracing is otherwise dormant — `tracesSampler` in `plugins/index.ts`
 * returns 0 for normal sessions. Flipping this flag on lets that sampler
 * capture transactions for the duration of the recorded session, so the
 * resulting Session Replay shows performance metrics (navigation/interaction
 * spans, network timing). Without any sampled transactions the replay has no
 * performance data attached.
 */
let recordingActive = false

/** Marks the current session as an active support recording. */
export function markSessionRecordingActive(): void {
  recordingActive = true
}

/** Clears the active support recording flag (tracing goes dormant again). */
export function markSessionRecordingInactive(): void {
  recordingActive = false
}

/** Whether a support recording is currently active (consumed by `tracesSampler`). */
export function isSessionRecordingActive(): boolean {
  return recordingActive
}
